import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionRoute, type PermissionRouteData } from '@exam-center/router';

interface AdminExamCenterLocationDetailsPermissionRouteProps {
  roomId: string;
}

export default function AdminExamCenterLocationDetailsPermissionRoute(
  props: Readonly<AdminExamCenterLocationDetailsPermissionRouteProps>,
) {
  const { roomId } = props;

  const routes: PermissionRouteData[] = [
    {
      path: '/admin/exam-location/locations/:roomId',
      requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW],
      params: {
        roomId,
      },
    },
    {
      path: '/admin/exam-location/locations/:roomId/usage',
      requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_USAGE.VIEW],
      params: {
        roomId,
      },
    },
  ];
  return <PermissionRoute routes={routes} />;
}
